import {create} from "zustand";

interface ToasterState {
  status: string;
  message: string;
  isVisible: boolean;
  showToaster: (status: string, message: string) => void;
  hideToaster: () => void;
}

export const useToasterStore = create<ToasterState>((set) => ({
  status: "info",
  message: "",
  isVisible: false,
  showToaster: (status, message) => {
    set({ status, message, isVisible: true });
    // Set timeout to hide after 3 seconds
    setTimeout(() => {
      set({ isVisible: false });
    }, 3000);
  },
  hideToaster: () => set({ isVisible: false }),
}));
